/**
 * Created by Cathy yao on 12/02/2021.
 * Description:
 * Add user password dialog component
 * ------ maintenance history ------
 * Allow web-only Users with local Authentication to change password
 *
 */
import { OnInit, Component, OnDestroy, Input } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { catchError, filter, take } from 'rxjs/operators';
import { StoreQuerierService } from '../../services/store-querier.service';
import { UserPasswordService } from '../../components/user-password-dialog/user-password.service';
import { UntypedFormControl } from '@angular/forms';
import { AuthService } from '../../tamalelibs/services/auth.service';
import { UsersService } from '../../tamalelibs/services/users.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { SystemUser } from '../../tamalelibs/models/user.model';

@Component({
    selector: 'user-password-dialog',
    templateUrl: './user-password-dialog.component.html',
    styleUrls: ['./user-password-dialog.component.scss'],
})
export class PasserwordDialogComponent implements OnInit, OnDestroy {
    confirmedPWD = new UntypedFormControl('');
    confirmedPWDvalue?: string;
    dialogWidth = 710;
    isProgressing = false;
    opened: boolean;
    oldpasswordvalue?: string;
    oldpassword = new UntypedFormControl('');
    passwordvalue?: string;
    password = new UntypedFormControl('');

    private _isChangeConfig = false;
    private _suscriptions: Subscription[] = [];
    private _currentUser: SystemUser;

    constructor(
        private _authService: AuthService,
        private _UsersService: UsersService,
        private _alertWindow: AlertWindowService,
        private _toast: ToastService,
        private _userPasswordService: UserPasswordService,
        private _storeQuerier: StoreQuerierService,
    ) {
    }

    ngOnInit() {
        this._currentUser = this._storeQuerier.getCurrentUser();
        this._suscriptions.push(
            this._userPasswordService.dialogOpen$.pipe(
                filter(() => !this.opened),
            ).subscribe(() => {
                this.opened = true;
            }));
    }

    ngOnDestroy(): void {
        this._suscriptions.forEach(subscription => subscription.unsubscribe());
    }

    clickClose() {
        if (this._isChangeConfig) {
            const subscription = this._alertWindow.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?'], 'Discard', 'Cancel')
                .subscribe((result: boolean) => {
                    if (result) {
                        this.opened = false;
                        this._clearData();
                    }
                    subscription.unsubscribe();
                });
        } else {
            this.opened = false;
            this._clearData();
        }
    }

    onChangePassword() {
        if (this._isPasswordValid()) {
            this.isProgressing = true;
            this._UsersService.userPasswordChangePatch(this._currentUser.id, this._authService.encryptPassword(this.passwordvalue), this._authService.encryptPassword(this.oldpasswordvalue)).pipe(
                take(1),
                catchError((error) => {
                    if (error.message.indexOf('wrong old password') > -1) {
                        this.oldpassword.setErrors({
                            notMatch: true
                        });
                        this.isProgressing = false;
                    } else {
                        this.isProgressing = false;
                        const _successToast: NotificationOptions = {
                            message: error.message,
                            style: NotificationStyles.Error
                        };
                        this._toast.notify(_successToast);
                    }

                    return of(null);
                }))
                .subscribe(res => {
                    if (res) {
                        this.isProgressing = false;
                        const successMessage = 'Your password is changed successfully, please use new password for your next time login.';
                        const _successToast: NotificationOptions = {
                            message: successMessage,
                            style: NotificationStyles.Success
                        };
                        this._toast.notify(_successToast);
                        this.opened = false;
                        this._clearData();
                    }
                });
        }
    }

    clickConfirmPasswordChange() {
        this._isChangeConfig = true;
    }

    clickOldPasswordChange() {
        this._isChangeConfig = true;
    }

    clickNewPasswordChange() {
        this._isChangeConfig = true;
        /** confirmedPWD should be cleared when the password is changed each time */
        if (this.passwordvalue === '') {
            this.confirmedPWDvalue = '';
        }
    }

    private _clearData() {
        this.oldpasswordvalue = '';
        this.passwordvalue = '';
        this.confirmedPWDvalue = '';
        this._isChangeConfig = false;
    }

    private _isPasswordValid(): boolean {
        let isValid = true;
        if (!this.oldpassword.value) {
            this.oldpassword.setErrors({
                required: true,
            });
            isValid = false;
        }
        if (!this.password.value || (this.password.value && this.passwordvalue.trim().length === 0)) {
            this.password.setErrors({
                required: true
            });
            isValid = false;
        }

        if (!this.confirmedPWD.value || (this.confirmedPWDvalue && this.confirmedPWDvalue.trim().length === 0)) {
            this.confirmedPWD.setErrors({
                required: true
            });
            isValid = false;
        } else if (this.confirmedPWDvalue !== this.passwordvalue) {
            this.confirmedPWD.setErrors({
                notMatch: true
            });
            isValid = false;
        }
        return isValid;
    }
}



